// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__10Fpn","right":"styles_right__1gSU-"};